<template>
  <div class="flex space_between _navBar">
    <div class="left" @click="onNavLeft" v-if="leftShow">
      <van-icon name="arrow-left" color="white" size=".5rem"/>
      <span v-if="leftText" class="f14">{{ leftText }}</span></div>
    <div class="title f16">{{ title }}</div>
    <div class="right" @click="onNavRight" v-if="rightShow">{{ rightText }}</div>
  </div>
</template>
<script>
export default {
  name: "navBar",
  props: {
    leftShow: {type: Boolean, default: true},//是否显示左侧
    leftText: {type: String, default: '返回'},//左侧文字
    title: {type: String, default: '标题'}, //标题
    rightText: {type: String, default: ''},//右侧文字
    rightShow: {type: Boolean, default: false},//是否显示右侧
  },
  data() {
    return {}
  },
  methods: {
    //点击左侧
    onNavLeft() {
      history.go(-1)
    },
    //点击右侧
    onNavRight() {
      this.$emit("onNavRight");
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/navBar.vue